/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const UserCredentials = core.serialization.object({
    email: core.serialization.string(),
    password: core.serialization.string(),
});
